import { useMemo } from 'react'
import { Table } from 'antd'
import dayjs from 'dayjs'
import { Button, Popconfirm } from 'antd'
import { DeleteOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { useUnlinkFaultFromIssue } from '../hooks/Issues'

const ProblemUnlinkButton = ({ fault, intl, removeFault }) => {
  return (
    <Popconfirm
      title={intl.formatMessage({
        defaultMessage: 'Delete Problem From Issue?',
        id: 'incidentMgmt.problemUnlinkButton.deleteIssue',
      })}
      onConfirm={() => removeFault(fault)}
      okText={intl.formatMessage({
        defaultMessage: 'Yes',
        id: 'incidentMgmt.problemUnlinkButton.deleteYes',
      })}
      cancelText={intl.formatMessage({
        defaultMessage: 'No',
        id: 'incidentMgmt.problemUnlinkButton.deleteNo',
      })}
      okType="danger"
      icon={
        <QuestionCircleOutlined
          style={{ color: 'var(--color-component-danger)' }}
        />
      }
    >
      <Button variant="outlined" size="small" danger>
        <DeleteOutlined />
      </Button>
    </Popconfirm>
  )
}

export const ProblemList = ({ problems, intl, setFault, issue }) => {
  const unlinkFault = useUnlinkFaultFromIssue()
  const removeFault = (fault) => {
    unlinkFault.mutate(
      { issue_id: issue.id, fault_id: fault.id },
      {
        onSuccess: () => {
          const newFault = structuredClone(fault)
          newFault.problems = problems.filter((flt) => flt.id !== fault.id)
          setFault(newFault)
        },
      },
    )
  }
  const cols = [
    {
      title: 'VIN',
      render: (record) => record.vin,
    },
    {
      title: 'Timestamp',
      render: (record) => dayjs(record.created_at).format('MM/DD/YYYY h:mma'),
    },
    {
      title: 'Notes',
      render: (record) => record.note,
      ellipsis: true,
    },
    {
      title: 'UserID',
      render: (record) => record.created_by,
      ellipsis: true,
    },
  ]
  if (!!issue && !!issue.id) {
    cols.push({
      title: '',
      key: 'prob-del-col',
      render: (record) =>
        ProblemUnlinkButton({ fault: record, intl, removeFault }),
    })
  }
  const columns = useMemo(() => cols, [problems, issue])
  return problems.length > 0 ? (
    <Table
      columns={columns}
      dataSource={problems}
      id="problem-list"
      pagination={{
        pageSize: 3,
        hideOnSinglePage: true,
      }}
    />
  ) : (
    ''
  )
}
